// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme-light .tippy-box[data-theme~=light][data-theme~=bell-popover] {\n  border: 1px solid rgba(0, 0, 0, 0.12) !important;\n}", ""]);
// Exports
module.exports = exports;
